(function() {
    window.c24 = window.c24 || {};
    window.c24.lp = window.c24.lp || {};

    window.c24.lp.activities = window.c24.lp.activities || {};

    window.c24.lp.activities.mpdv = {
        getVehicleLabel: function(vehicleId) {
            const vehicleMap = {
                'K1': 'Mokick bis 50 km/h',
                'K2': 'Mokick bis 60 km/h',
                'K45': 'Mokick bis 45 km/h',
                'M2': 'Mofa bis 25 km/h',
                'ES20': 'E-Scooter bis 20 km/h',
                'M3': 'Moped bis 50 km/h',
                'M4': 'Moped bis 60 km/h',
                'M45': 'Moped bis 45 km/h',
                'R1': 'Roller bis 50 km/h',
                'R2': 'Roller bis 60 km/h',
                'R45': 'Roller bis 45 km/h',
                'PE1': 'E-Bike/Pedelec bis 45 km/h',
                'KR4': 'Krankenfahrstuhl bis 15 km/h',
                'KKR4': 'Kleinkraftrad dreirädrig bis 45 km/h',
                'LKR4': 'Leichtkraftfahrzeug bis 45 km/h',
                'KR5': 'Krankenfahrstuhl bis 30 km/h',
            };

            return vehicleMap[vehicleId] || null;
        },

        getCoverageLabel: function(coverageType) {
            const coverageMap = {
                'haftpflicht': 'Haftpflicht',
                'withTeilkasko': 'Haftpflicht und Teilkasko',
            };

            return coverageMap[coverageType] || null;
        },
    };
})();
